
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import viewableImg from '@/components/viewableImg.vue';
	import RadioButton from '@/components/radio-button.vue';
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"
  import {
    tempAddOrderQRCodelist,
    tempAddOrderstatislist,
    tempAddOrderdetaillist,
    tempAddOrderminBuyCountInfo,
    tempAddOrderminBuyCountmodify  
  } from "@/api/order"
  
	import {
		providerSelectItem
	} from '@/api/supplier';
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      viewableImg,
      RadioButton
    }
  })

  export default class ProductList extends Vue {

    private minimum = 0
    private radioType = 1
    protected radioList = [
      {
				value: 1,
				label: "加单汇总数据"
			},
			{
				value: 2,
				label: "订单明细"
			},
			{
				value: 3,
				label: "链接明细"
			},
    ]
    private filterTime1 = [getSearchDate(2,false,-1)[0],getSearchDate(2,false,-1)[0]].join('/')
    private filterTime2 = [getSearchDate(2,false,-1)[0],getSearchDate(2,false,-1)[0]].join('/')
    private filterTime3 = ''
    private keywords1 = ''
    private keywords2 = ''
    private keywords3 = ''
    private orderstate = []
    private orderstatelist = [
      {value:0,label:'待支付'},
      {value:10,label:'待发货'},
      {value:20,label:'已发货'},
      {value:30,label:'已完成'},
      {value:40,label:'已取消'},
    ]
    private supplierNameKey1 = null
    private supplierNameKey2 = null
    private supplierNameKey3 = null
    private supplierList:any = []
    private hasorder = true
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private tablelist1:any = []
    private tablelist2:any = []
    private tablelist3:any = []
    private tableloading = false
    private showPreview = false
    private currentUrl = false


    private mounted () {

      this.getSupplierList()
      this.getsummarylist()      
      this.getleastnum()
      this.gettablelist()    
    }

    async getleastnum(){
      try{
        let res = await tempAddOrderminBuyCountInfo({})
        if(res.IsSuccess){
          this.minimum = res.Result.MinBuyCount
        }
      }finally{
        //
      }
    }
    async saveleast(){
      try{
        let res:any = await tempAddOrderminBuyCountmodify({
          MinBuyCount:this.minimum||0
        })
        if(res.IsSuccess){
          this.$message.success(res.Message)
          this.getleastnum()
        }
      }finally{
        //
      }
    }
 private changetype(e){
      this.doSearch()
    }
    private exportfile(){
      let url = location.origin
      if(this.radioType == 1){
        url += '/pc/order/tempAddOrder/statis/list'
        url += '?Keywords=' + encodeURIComponent(this.keywords1)
        url += '&ProviderId=' + (this.supplierNameKey1||'')
        if (this.filterTime1) {
          let dt = this.filterTime1.split('/')
          url += '&StartTime=' + dt[0]
          url += '&EndTime=' + nextDay(dt[1],1)
        }
      }else if(this.radioType == 2){
        url += '/pc/order/tempAddOrder/detail/list'
        url += '?Keywords=' + encodeURIComponent(this.keywords2)
        url += '&ProviderId=' + (this.supplierNameKey2||'')
        url += '&OrderStateList=' + this.orderstate
        if (this.filterTime2) {
          let dt = this.filterTime2.split('/')
          url += '&StartTime=' + dt[0]
          url += '&EndTime=' + nextDay(dt[1],1)
        }
      }
      // console.log(url)
      // return
      window.open(url)
    }
    private lookdetail(row){
      this.radioType = 2
      this.filterTime2 = this.filterTime1
      this.keywords2 = row.ProductName
      this.orderstate = [10,20]
      this.doSearch()
    }
    private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplierList = res.Result.map(v=>{
					return {
						value: v.Id,
						label: v.ProviderName
					}
				})
			}finally{
        //
      }
		}    private generate(){
      this.$router.push({
        path:'generate'
      })
    }
    private doSearch(){
      this.pageNo = 1
      this.judgment()
    }
    private judgment(){
      if(this.radioType == 1){
        this.getsummarylist()
      }else if(this.radioType == 2){
        this.getorderlist()
      }else if(this.radioType == 3){
      this.gettablelist()
    }
    }
    private clearSearch(){
      if(this.radioType == 1){
        this.filterTime1 = [getSearchDate(2,false,-1)[0],getSearchDate(2,false,-1)[0]].join('/')
        this.keywords1 = ''
        this.supplierNameKey1 = null
      }else if(this.radioType == 2){
        this.filterTime2 = [getSearchDate(2,false,-1)[0],getSearchDate(2,false,-1)[0]].join('/')
        this.keywords2 = ''
        this.supplierNameKey2 = null
        this.orderstate = []
      }else if(this.radioType == 3){
        this.filterTime3 = ''
        this.keywords3 = ''
        this.supplierNameKey3 = null
        this.hasorder = true
    }
      this.pageNo = 1
      this.judgment()
    }
    private changePage(e){
      this.pageNo = e
      this.judgment()
    }
    private async getsummarylist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords1,
          ProviderId:this.supplierNameKey1,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime1) {
          var dt = this.filterTime1.split('/')
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await tempAddOrderstatislist(data)
        if(res.IsSuccess){
          this.tablelist1 = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async getorderlist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords2,
          ProviderId:this.supplierNameKey2,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          OrderStateList:this.orderstate,
        }
        if (this.filterTime2) {
          var dt = this.filterTime2.split('/')
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await tempAddOrderdetaillist(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords3,
          ProviderId:this.supplierNameKey3,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime3) {
          var dt = this.filterTime3.split('/')
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res:any = await tempAddOrderQRCodelist(data)
        if(res.IsSuccess){
          this.tablelist3 = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
